module.exports = __webpack_public_path__ + "media/images/banner/wowjapan/sidebar/ja-044ef2c1dd8a48ba7ec67bf712250bb1.jpg";